import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table } from 'antd';
import './profile.css';
import logo from './assets/CSSH logo png.png';
import logoutIcon from './assets/turn-off.png'; 
import { useNavigate } from 'react-router-dom';
import admin from './assets/admin.png'

function Profile() {
    const columns = [
        {
            title: 'id',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Age',
            dataIndex: 'age',
            key: 'age',
        },
        {
            title: 'mobile',
            dataIndex: 'mobile',
            key: 'mobile',
        },
        {
            title: 'gender',
            dataIndex: 'gender',
            key: 'gender',
        },
        {
            title: 'score',
            dataIndex: 'score',
            key: 'score',
        },
        {
            title: 'pdf_path',
            dataIndex: 'pdf_path',
            key: 'pdf_path',
              render: (pdfUrl) => (
      <a href={pdfUrl} download>
        Download PDF
      </a>
    ),
        },
    ];

    const [user, setUser] = useState([]);
    const [searchName, setSearchName] = useState('');
    const [searchMobile, setSearchMobile] = useState('');
    

    const [filteredData, setFilteredData] = useState(user);
const navigate=useNavigate();
    const handleFilter = () => {
        const filtered = user.filter((item) => {
            const matchesName = item.name.toLowerCase().includes(searchName.toLowerCase());
            return matchesName;
        });
        setFilteredData(filtered);
    };
    const handleFilter2 = () => {
        const filtered = user.filter((item) => {
            const matchesName = item.mobile.toLowerCase().includes(searchMobile.toLowerCase());
            return matchesName;
        });
        setFilteredData(filtered);
    };
    const handleReset = () => {
        setSearchName('');
        setSearchMobile('')
        setFilteredData(user);
        
    };

    const handleLogout = () => {
        console.log('Logout');
        localStorage.removeItem('formData'); // Clear token
        alert('Logged out successfully');
        // window.location.reload(); // Refresh or redirect to login page
        navigate('/')
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get('https://nsureback.asianspinehospital.com/api');
                setUser(response.data);
                setFilteredData(response.data); 
            } catch (error) {
                alert(error.response?.data?.message || 'Error fetching profile.');
            }
        };

        fetchData();
    },[]);

    return (
       
            <div  className='container'>
            <header className="header">
                <div className="logo">
                    <img src={logo} alt="Logo" />
                </div>
                <div className="logout-info">
                    {/* <span>Welcome, User</span> */}
                    <button className="logout-button">
                        <img src={admin} alt="Logout" className="logout-icon" />
                    </button>
                    <span>Naresh </span>
                    <button onClick={handleLogout} className="logout-button">
                        <img src={logoutIcon} alt="Logout" className="logout-icon" />
                    </button><span>Logout</span>
                </div>
            </header>
            
            <div >
               <div className="container2">
  <div className="count">Total Count: {filteredData.length}</div>

 <div className="container3"><div className="search">
    <input type="text" placeholder="Search by Name..."   value={searchName}
                            onChange={(e) => setSearchName(e.target.value)}
                           
                            handleFilter={(e) =>handleFilter}/>
    <button onClick={handleFilter}>Search</button>
  </div>
  <div className="search">
    <input type="text" placeholder="Search by Mobile..."   value={searchMobile}
                            onChange={(e) => setSearchMobile(e.target.value)}
                           
                            handleFilter={(e) =>handleFilter2}/>
    <button onClick={handleFilter2}>Search</button>
  </div>
  </div>
</div>

              
<div className='tabledis'>
            <Table dataSource={filteredData} columns={columns} />;
            </div>
        </div>
        </div>
        
    );
}

export default Profile;
